import { render, staticRenderFns } from "./HeadAd.vue?vue&type=template&id=45611576&scoped=true&"
import script from "./HeadAd.vue?vue&type=script&lang=js&"
export * from "./HeadAd.vue?vue&type=script&lang=js&"
import style0 from "./HeadAd.vue?vue&type=style&index=0&id=45611576&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45611576",
  null
  
)

export default component.exports